import Link from "next/link";
import Image from "next/image";
import { sidebarWidth } from "@/features/common/style/commonClass";

interface HeaderProps {
  title: string;
  prefix?: string;
}

export function Header({ title, prefix = "" }: HeaderProps) {
  const normalizedPrefix = prefix === "/" ? "" : prefix.replace(/\/+$/, "");
  const logoHref =
    normalizedPrefix === "/login"
      ? "/login"
      : `${normalizedPrefix}/top/new` || "/top/new";

  return (
    <header className="app-header fixed top-0 inset-x-0 z-50 flex h-16 items-center justify-between border-b border-black/5 bg-white/70 pr-10 backdrop-blur-xl backdrop-saturate-150">
      <div className={`flex h-16 items-center px-4 ${sidebarWidth}`}>
        <Link href={logoHref} className="flex items-center">
          <Image src="/byAgentLogo.svg" alt="byAgent Logo" width={120} height={36} />
        </Link>
      </div>
      <span className="text-sm font-medium text-muted-foreground">{title}</span>
    </header>
  );
}
